import { c as _c } from "react/compiler-runtime";
import { FaroSwitch } from "@components/common/faro-switch";
import { SendFeedbackDialog } from "@components/header/send-feedback-dialog";
import { SidebarHolobuilderTooltip } from "@components/sidebar/sidebar-holobuilder/sidebar-holobuilder-tooltip";
import { getHBDashboardUrl } from "@components/sidebar/sidebar-holobuilder/sidebar-holobuilder-utils";
import { FontWeights, List, Tooltip } from "@flat-ui";
import { Box, Stack } from "@mui-wrapper";
import { canOpenWebEditorSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { withEllipsis } from "@styles/common-styles";
import { SidebarEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";
/** Renders a sidebar item that navigates to the HoloBuilder dashboard */
export function SidebarHolobuilderItem(t0) {
  const $ = _c(31);
  const {
    isSidebarFullSize
  } = t0;
  const {
    trackAsyncEvent
  } = useTrackEvent();
  const [isSwitchChecked, setIsSwitchChecked] = useState(true);
  const [shouldShowFeedbackDialog, setShouldShowFeedbackDialog] = useState(false);
  const isOpenInHBButtonEnabled = useAppSelector(canOpenWebEditorSelector);
  let t1;
  if ($[0] !== trackAsyncEvent) {
    t1 = async function navigateToHBDashboard() {
      await trackAsyncEvent({
        name: SidebarEvents.navigateToHBDashboard
      });
      const hbUrl = getHBDashboardUrl();
      window.location.assign(hbUrl);
    };
    $[0] = trackAsyncEvent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const navigateToHBDashboard = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function handleFeedbackDialogClose() {
      setIsSwitchChecked(true);
      setShouldShowFeedbackDialog(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleFeedbackDialogClose = t2;
  let t3;
  if ($[3] !== trackAsyncEvent) {
    t3 = async function handleSwitchChange(_, willBeChecked) {
      await trackAsyncEvent({
        name: SidebarEvents.toggleSDBAccess,
        props: {
          UseNewDashboard: willBeChecked
        }
      });
      if (!willBeChecked) {
        setShouldShowFeedbackDialog(true);
      }
      setIsSwitchChecked(willBeChecked);
    };
    $[3] = trackAsyncEvent;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleSwitchChange = t3;
  if (!isOpenInHBButtonEnabled) {
    return null;
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      paddingY: 0,
      mb: "24px"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SidebarHolobuilderTooltip />;
    t6 = {
      maxWidth: 320
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  const t7 = isSidebarFullSize ? "18px" : 0;
  const t8 = isSidebarFullSize ? "2px" : 0;
  const t9 = isSidebarFullSize ? "space-between" : "center";
  let t10;
  if ($[8] !== t7 || $[9] !== t8 || $[10] !== t9) {
    t10 = {
      cursor: "pointer",
      pl: t7,
      pr: t8,
      justifyContent: t9,
      alignItems: "center"
    };
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== isSidebarFullSize) {
    t11 = isSidebarFullSize && <Stack sx={{
      ...withEllipsis
    }}><Box sx={{
        color: "text.primary",
        fontSize: "10px",
        lineHeight: "14px"
      }}>Try the</Box><Box sx={{
        color: "text.primary",
        fontSize: "12px",
        fontWeight: FontWeights.Bold,
        letterSpacing: "0.48px",
        textTransform: "uppercase",
        ...withEllipsis
      }}>New Dashboard</Box></Stack>;
    $[12] = isSidebarFullSize;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = isSidebarFullSize ? "12px" : 0;
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      display: "none"
    };
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t12) {
    t14 = {
      position: "relative",
      top: "6px",
      marginRight: t12,
      "& .MuiTypography-root:empty": t13
    };
    $[15] = t12;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== handleSwitchChange || $[18] !== isSwitchChecked || $[19] !== t14) {
    t15 = <FaroSwitch checked={isSwitchChecked} onChange={handleSwitchChange} sx={t14} />;
    $[17] = handleSwitchChange;
    $[18] = isSwitchChecked;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t15) {
    t16 = <Tooltip component="div" title={t5} tooltipSx={t6}><Stack direction="row" spacing={1} sx={t10}>{t11}{t15}</Stack></Tooltip>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== navigateToHBDashboard || $[26] !== shouldShowFeedbackDialog) {
    t17 = <SendFeedbackDialog isDialogOpen={shouldShowFeedbackDialog} onClose={handleFeedbackDialogClose} showXButton={true} title="How was your experience with the dashboard?" feedbackQuestionText="Before you switch back, can you share some feedback?" featureName="Switch to HB Dashboard" confirmText="Submit and switch back" cancelText="Switch without feedback" onSubmitFeedback={navigateToHBDashboard} onCancel={navigateToHBDashboard} />;
    $[25] = navigateToHBDashboard;
    $[26] = shouldShowFeedbackDialog;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t16 || $[29] !== t17) {
    t18 = <List sx={t4}>{t16}{t17}</List>;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  return t18;
}